/**
 * @author Fellipe Orsini
 * 
 * @package blazebot-webapp\app\assets\js\utils.js
 */

//const moment = require('moment-timezone');
var moment = require('moment-timezone');
const XLSX = require('xlsx');

const countryList = [
    {
        "name": "Afghanistan",
        "code": "AF"
    },
    {
        "name": "Albania",
        "code": "AL"
    },
    {
        "name": "Algeria",
        "code": "DZ"
    },
    {
        "name": "American Samoa",
        "code": "AS"
    },
    {
        "name": "Andorra",
        "code": "AD"
    },
    {
        "name": "Angola",
        "code": "AO"
    },
    {
        "name": "Anguilla",
        "code": "AI"
    },
    {
        "name": "Antarctica",
        "code": "AQ"
    },
    {
        "name": "Antigua and Barbuda",
        "code": "AG"
    },
    {
        "name": "Argentina",
        "code": "AR"
    },
    {
        "name": "Armenia",
        "code": "AM"
    },
    {
        "name": "Aruba",
        "code": "AW"
    },
    {
        "name": "Asia/Pacific Region",
        "code": "AP"
    },
    {
        "name": "Australia",
        "code": "AU"
    },
    {
        "name": "Austria",
        "code": "AT"
    },
    {
        "name": "Azerbaijan",
        "code": "AZ"
    },
    {
        "name": "Bahamas",
        "code": "BS"
    },
    {
        "name": "Bahrain",
        "code": "BH"
    },
    {
        "name": "Bangladesh",
        "code": "BD"
    },
    {
        "name": "Barbados",
        "code": "BB"
    },
    {
        "name": "Belarus",
        "code": "BY"
    },
    {
        "name": "Belgium",
        "code": "BE"
    },
    {
        "name": "Belize",
        "code": "BZ"
    },
    {
        "name": "Benin",
        "code": "BJ"
    },
    {
        "name": "Bermuda",
        "code": "BM"
    },
    {
        "name": "Bhutan",
        "code": "BT"
    },
    {
        "name": "Bolivia",
        "code": "BO"
    },
    {
        "name": "Bonaire, Sint Eustatius and Saba",
        "code": "BQ"
    },
    {
        "name": "Bosnia and Herzegovina",
        "code": "BA"
    },
    {
        "name": "Botswana",
        "code": "BW"
    },
    {
        "name": "Bouvet Island",
        "code": "BV"
    },
    {
        "name": "Brazil",
        "code": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "code": "IO"
    },
    {
        "name": "Brunei Darussalam",
        "code": "BN"
    },
    {
        "name": "Bulgaria",
        "code": "BG"
    },
    {
        "name": "Burkina Faso",
        "code": "BF"
    },
    {
        "name": "Burundi",
        "code": "BI"
    },
    {
        "name": "Cambodia",
        "code": "KH"
    },
    {
        "name": "Cameroon",
        "code": "CM"
    },
    {
        "name": "Canada",
        "code": "CA"
    },
    {
        "name": "Cape Verde",
        "code": "CV"
    },
    {
        "name": "Cayman Islands",
        "code": "KY"
    },
    {
        "name": "Central African Republic",
        "code": "CF"
    },
    {
        "name": "Chad",
        "code": "TD"
    },
    {
        "name": "Chile",
        "code": "CL"
    },
    {
        "name": "China",
        "code": "CN"
    },
    {
        "name": "Christmas Island",
        "code": "CX"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "code": "CC"
    },
    {
        "name": "Colombia",
        "code": "CO"
    },
    {
        "name": "Comoros",
        "code": "KM"
    },
    {
        "name": "Congo",
        "code": "CG"
    },
    {
        "name": "Congo, The Democratic Republic of the",
        "code": "CD"
    },
    {
        "name": "Cook Islands",
        "code": "CK"
    },
    {
        "name": "Costa Rica",
        "code": "CR"
    },
    {
        "name": "Croatia",
        "code": "HR"
    },
    {
        "name": "Cuba",
        "code": "CU"
    },
    {
        "name": "Curaçao",
        "code": "CW"
    },
    {
        "name": "Cyprus",
        "code": "CY"
    },
    {
        "name": "Czech Republic",
        "code": "CZ"
    },
    {
        "name": "Côte d'Ivoire",
        "code": "CI"
    },
    {
        "name": "Denmark",
        "code": "DK"
    },
    {
        "name": "Djibouti",
        "code": "DJ"
    },
    {
        "name": "Dominica",
        "code": "DM"
    },
    {
        "name": "Dominican Republic",
        "code": "DO"
    },
    {
        "name": "Ecuador",
        "code": "EC"
    },
    {
        "name": "Egypt",
        "code": "EG"
    },
    {
        "name": "El Salvador",
        "code": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "code": "GQ"
    },
    {
        "name": "Eritrea",
        "code": "ER"
    },
    {
        "name": "Estonia",
        "code": "EE"
    },
    {
        "name": "Ethiopia",
        "code": "ET"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "code": "FK"
    },
    {
        "name": "Faroe Islands",
        "code": "FO"
    },
    {
        "name": "Fiji",
        "code": "FJ"
    },
    {
        "name": "Finland",
        "code": "FI"
    },
    {
        "name": "France",
        "code": "FR"
    },
    {
        "name": "French Guiana",
        "code": "GF"
    },
    {
        "name": "French Polynesia",
        "code": "PF"
    },
    {
        "name": "French Southern Territories",
        "code": "TF"
    },
    {
        "name": "Gabon",
        "code": "GA"
    },
    {
        "name": "Gambia",
        "code": "GM"
    },
    {
        "name": "Georgia",
        "code": "GE"
    },
    {
        "name": "Germany",
        "code": "DE"
    },
    {
        "name": "Ghana",
        "code": "GH"
    },
    {
        "name": "Gibraltar",
        "code": "GI"
    },
    {
        "name": "Greece",
        "code": "GR"
    },
    {
        "name": "Greenland",
        "code": "GL"
    },
    {
        "name": "Grenada",
        "code": "GD"
    },
    {
        "name": "Guadeloupe",
        "code": "GP"
    },
    {
        "name": "Guam",
        "code": "GU"
    },
    {
        "name": "Guatemala",
        "code": "GT"
    },
    {
        "name": "Guernsey",
        "code": "GG"
    },
    {
        "name": "Guinea",
        "code": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "code": "GW"
    },
    {
        "name": "Guyana",
        "code": "GY"
    },
    {
        "name": "Haiti",
        "code": "HT"
    },
    {
        "name": "Heard Island and Mcdonald Islands",
        "code": "HM"
    },
    {
        "name": "Holy See (Vatican City State)",
        "code": "VA"
    },
    {
        "name": "Honduras",
        "code": "HN"
    },
    {
        "name": "Hong Kong",
        "code": "HK"
    },
    {
        "name": "Hungary",
        "code": "HU"
    },
    {
        "name": "Iceland",
        "code": "IS"
    },
    {
        "name": "India",
        "code": "IN"
    },
    {
        "name": "Indonesia",
        "code": "ID"
    },
    {
        "name": "Iran, Islamic Republic Of",
        "code": "IR"
    },
    {
        "name": "Iraq",
        "code": "IQ"
    },
    {
        "name": "Ireland",
        "code": "IE"
    },
    {
        "name": "Isle of Man",
        "code": "IM"
    },
    {
        "name": "Israel",
        "code": "IL"
    },
    {
        "name": "Italy",
        "code": "IT"
    },
    {
        "name": "Jamaica",
        "code": "JM"
    },
    {
        "name": "Japan",
        "code": "JP"
    },
    {
        "name": "Jersey",
        "code": "JE"
    },
    {
        "name": "Jordan",
        "code": "JO"
    },
    {
        "name": "Kazakhstan",
        "code": "KZ"
    },
    {
        "name": "Kenya",
        "code": "KE"
    },
    {
        "name": "Kiribati",
        "code": "KI"
    },
    {
        "name": "Korea, Republic of",
        "code": "KR"
    },
    {
        "name": "Kuwait",
        "code": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "code": "KG"
    },
    {
        "name": "Laos",
        "code": "LA"
    },
    {
        "name": "Latvia",
        "code": "LV"
    },
    {
        "name": "Lebanon",
        "code": "LB"
    },
    {
        "name": "Lesotho",
        "code": "LS"
    },
    {
        "name": "Liberia",
        "code": "LR"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "code": "LY"
    },
    {
        "name": "Liechtenstein",
        "code": "LI"
    },
    {
        "name": "Lithuania",
        "code": "LT"
    },
    {
        "name": "Luxembourg",
        "code": "LU"
    },
    {
        "name": "Macao",
        "code": "MO"
    },
    {
        "name": "Madagascar",
        "code": "MG"
    },
    {
        "name": "Malawi",
        "code": "MW"
    },
    {
        "name": "Malaysia",
        "code": "MY"
    },
    {
        "name": "Maldives",
        "code": "MV"
    },
    {
        "name": "Mali",
        "code": "ML"
    },
    {
        "name": "Malta",
        "code": "MT"
    },
    {
        "name": "Marshall Islands",
        "code": "MH"
    },
    {
        "name": "Martinique",
        "code": "MQ"
    },
    {
        "name": "Mauritania",
        "code": "MR"
    },
    {
        "name": "Mauritius",
        "code": "MU"
    },
    {
        "name": "Mayotte",
        "code": "YT"
    },
    {
        "name": "Mexico",
        "code": "MX"
    },
    {
        "name": "Micronesia, Federated States of",
        "code": "FM"
    },
    {
        "name": "Moldova, Republic of",
        "code": "MD"
    },
    {
        "name": "Monaco",
        "code": "MC"
    },
    {
        "name": "Mongolia",
        "code": "MN"
    },
    {
        "name": "Montenegro",
        "code": "ME"
    },
    {
        "name": "Montserrat",
        "code": "MS"
    },
    {
        "name": "Morocco",
        "code": "MA"
    },
    {
        "name": "Mozambique",
        "code": "MZ"
    },
    {
        "name": "Myanmar",
        "code": "MM"
    },
    {
        "name": "Namibia",
        "code": "NA"
    },
    {
        "name": "Nauru",
        "code": "NR"
    },
    {
        "name": "Nepal",
        "code": "NP"
    },
    {
        "name": "Netherlands",
        "code": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "code": "AN"
    },
    {
        "name": "New Caledonia",
        "code": "NC"
    },
    {
        "name": "New Zealand",
        "code": "NZ"
    },
    {
        "name": "Nicaragua",
        "code": "NI"
    },
    {
        "name": "Niger",
        "code": "NE"
    },
    {
        "name": "Nigeria",
        "code": "NG"
    },
    {
        "name": "Niue",
        "code": "NU"
    },
    {
        "name": "Norfolk Island",
        "code": "NF"
    },
    {
        "name": "North Korea",
        "code": "KP"
    },
    {
        "name": "North Macedonia",
        "code": "MK"
    },
    {
        "name": "Northern Mariana Islands",
        "code": "MP"
    },
    {
        "name": "Norway",
        "code": "NO"
    },
    {
        "name": "Oman",
        "code": "OM"
    },
    {
        "name": "Pakistan",
        "code": "PK"
    },
    {
        "name": "Palau",
        "code": "PW"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "code": "PS"
    },
    {
        "name": "Panama",
        "code": "PA"
    },
    {
        "name": "Papua New Guinea",
        "code": "PG"
    },
    {
        "name": "Paraguay",
        "code": "PY"
    },
    {
        "name": "Peru",
        "code": "PE"
    },
    {
        "name": "Philippines",
        "code": "PH"
    },
    {
        "name": "Pitcairn Islands",
        "code": "PN"
    },
    {
        "name": "Poland",
        "code": "PL"
    },
    {
        "name": "Portugal",
        "code": "PT"
    },
    {
        "name": "Puerto Rico",
        "code": "PR"
    },
    {
        "name": "Qatar",
        "code": "QA"
    },
    {
        "name": "Reunion",
        "code": "RE"
    },
    {
        "name": "Romania",
        "code": "RO"
    },
    {
        "name": "Russian Federation",
        "code": "RU"
    },
    {
        "name": "Rwanda",
        "code": "RW"
    },
    {
        "name": "Saint Barthélemy",
        "code": "BL"
    },
    {
        "name": "Saint Helena",
        "code": "SH"
    },
    {
        "name": "Saint Kitts and Nevis",
        "code": "KN"
    },
    {
        "name": "Saint Lucia",
        "code": "LC"
    },
    {
        "name": "Saint Martin",
        "code": "MF"
    },
    {
        "name": "Saint Martin",
        "code": "MF"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "code": "PM"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "code": "VC"
    },
    {
        "name": "Samoa",
        "code": "WS"
    },
    {
        "name": "San Marino",
        "code": "SM"
    },
    {
        "name": "Sao Tome and Principe",
        "code": "ST"
    },
    {
        "name": "Saudi Arabia",
        "code": "SA"
    },
    {
        "name": "Senegal",
        "code": "SN"
    },
    {
        "name": "Serbia",
        "code": "RS"
    },
    {
        "name": "Serbia and Montenegro",
        "code": "CS"
    },
    {
        "name": "Seychelles",
        "code": "SC"
    },
    {
        "name": "Sierra Leone",
        "code": "SL"
    },
    {
        "name": "Singapore",
        "code": "SG"
    },
    {
        "name": "Sint Maarten",
        "code": "SX"
    },
    {
        "name": "Slovakia",
        "code": "SK"
    },
    {
        "name": "Slovenia",
        "code": "SI"
    },
    {
        "name": "Solomon Islands",
        "code": "SB"
    },
    {
        "name": "Somalia",
        "code": "SO"
    },
    {
        "name": "South Africa",
        "code": "ZA"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "code": "GS"
    },
    {
        "name": "South Sudan",
        "code": "SS"
    },
    {
        "name": "Spain",
        "code": "ES"
    },
    {
        "name": "Sri Lanka",
        "code": "LK"
    },
    {
        "name": "Sudan",
        "code": "SD"
    },
    {
        "name": "Suriname",
        "code": "SR"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "code": "SJ"
    },
    {
        "name": "Swaziland",
        "code": "SZ"
    },
    {
        "name": "Sweden",
        "code": "SE"
    },
    {
        "name": "Switzerland",
        "code": "CH"
    },
    {
        "name": "Syrian Arab Republic",
        "code": "SY"
    },
    {
        "name": "Taiwan",
        "code": "TW"
    },
    {
        "name": "Tajikistan",
        "code": "TJ"
    },
    {
        "name": "Tanzania, United Republic of",
        "code": "TZ"
    },
    {
        "name": "Thailand",
        "code": "TH"
    },
    {
        "name": "Timor-Leste",
        "code": "TL"
    },
    {
        "name": "Togo",
        "code": "TG"
    },
    {
        "name": "Tokelau",
        "code": "TK"
    },
    {
        "name": "Tonga",
        "code": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "code": "TT"
    },
    {
        "name": "Tunisia",
        "code": "TN"
    },
    {
        "name": "Turkey",
        "code": "TR"
    },
    {
        "name": "Turkmenistan",
        "code": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "code": "TC"
    },
    {
        "name": "Tuvalu",
        "code": "TV"
    },
    {
        "name": "Uganda",
        "code": "UG"
    },
    {
        "name": "Ukraine",
        "code": "UA"
    },
    {
        "name": "United Arab Emirates",
        "code": "AE"
    },
    {
        "name": "United Kingdom",
        "code": "GB"
    },
    {
        "name": "United States",
        "code": "US"
    },
    {
        "name": "United States Minor Outlying Islands",
        "code": "UM"
    },
    {
        "name": "Uruguay",
        "code": "UY"
    },
    {
        "name": "Uzbekistan",
        "code": "UZ"
    },
    {
        "name": "Vanuatu",
        "code": "VU"
    },
    {
        "name": "Venezuela",
        "code": "VE"
    },
    {
        "name": "Vietnam",
        "code": "VN"
    },
    {
        "name": "Virgin Islands, British",
        "code": "VG"
    },
    {
        "name": "Virgin Islands, U.S.",
        "code": "VI"
    },
    {
        "name": "Wallis and Futuna",
        "code": "WF"
    },
    {
        "name": "Western Sahara",
        "code": "EH"
    },
    {
        "name": "Yemen",
        "code": "YE"
    },
    {
        "name": "Zambia",
        "code": "ZM"
    },
    {
        "name": "Zimbabwe",
        "code": "ZW"
    },
    {
        "name": "Åland Islands",
        "code": "AX"
    }
];

require.ensure(['moment-timezone'], function (require) {
    function getTimestamp() {
        return moment().tz("America/Sao_Paulo").unix();
    }
    function getSaoPauloDateTime() {
        return moment().tz("America/Sao_Paulo").format("YYYY_MM_DD_HH_mm_ss");
    }
    exports.getSaoPauloDateTime = getSaoPauloDateTime;
    window.getSaoPauloDateTime = getSaoPauloDateTime;
    exports.getTimestamp = getTimestamp;
    window.getTimestamp = getTimestamp;
});

const getBaseDir = () => {
    return window._baseDir === undefined || null ? '/' : window._baseDir;
}

const customApiUrl = getBaseDir();
const customApi = {
    //"api/v1/business/insights": {}
}
const customData = {
    "HOMEPAGE_PIT_PN_LAST_7_DAYS": {},
    "HOMEPAGE_SCHEDULEMENT_REPORT_PN": {},
    "HOMEPAGE_HUNTER_GLASS_DOOR": {},
    "HOMEPAGE_AGENDA_REPORT": {}
}

var sendingHeartbeat = false;
var gettingUsers = false;
var gettingUnseenTicketsNotifications = false;

const getGameTypeFromBotType = (bot_type) => {
    //console.log('getGameTypeFromBotType', bot_type, window._sessionData.bot_types);
    return window._sessionData.bot_types?.[bot_type].game;
}


const disableForm = (divId) => {
    $(divId).find('input').each(function () {
        $(this).prop('disabled', true);
    });
    $(divId).find('button').each(function () {
        $(this).addClass('disabled');
    });
    $(divId).find('select').each(function () {
        $(this).addClass('disabled');
        $(this).prop('disabled', true);
    });
    $(divId).find('textarea').each(function () {
        $(this).addClass('disabled');
        $(this).prop('disabled', true);
    });
}

const enableForm = (divId) => {
    $(divId).find('input').each(function () {
        $(this).prop('disabled', false);
    });
    $(divId).find('button').each(function () {
        $(this).removeClass('disabled');
    });
    $(divId).find('select').each(function () {
        $(this).removeClass('disabled');
        $(this).prop('disabled', false);
    });
    $(divId).find('textarea').each(function () {
        $(this).removeClass('disabled');
        $(this).prop('disabled', false);
    });
}

const apiCall = (options = { method, endpoint, data, dataType, successCallback, errorCallback, formBlockContainer: false, formElement: false }) => {
    if (options.dataType === null) {
        options.dataType = 'json';
    }

    let endpoinnt = options.endpoint;
    let useCustomApi = false;

    let stringData = JSON.stringify(options.data);
    // check if customData has any strindData
    if (window._sessionData.isCustomApi) {
        for (let key in customData) {
            //console.log('stringData', stringData, key, stringData.indexOf(key));
            if (typeof stringData !== 'undefined') {
                if (stringData.indexOf(key) > -1) {
                    useCustomApi = true;
                    console.log('useCustomApi', stringData, key, stringData.indexOf(key), useCustomApi);
                    break;
                }
            }
        }

        if (customApi[options.endpoint])
            useCustomApi = true;
    }

    if (useCustomApi) {
        endpoinnt = options.endpoint.replace('api/', 'api_custom/');
    }

    let ajaxOpts = {
        async: true,
        type: options.method,
        url: useCustomApi ? customApiUrl + endpoinnt : getBaseDir() + options.endpoint,
        dataType: options.dataType,
        data: options.method === 'POST' || options.method === 'PUT' || options.method === 'DELETE' ? JSON.stringify(options.data) : options.data,
        contentType: options.dataType === 'json' ? "application/json" : "text/html",
        beforeSend: function (request) {
            if (useCustomApi) {
                request.setRequestHeader("Authorization", 'Bearer ' + window._sessionData.accessToken);
            }
        },
        success: function (body) {
            if (options.formBlockContainer !== false) {
                $(options.formBlockContainer).unblock();
                enableForm(options.formElement);
            }

            if (options.dataType === 'json' && typeof body.error === 'undefined' || null) {
                return alert('apiCall: Ocorreu um erro interno ao resgatar as informações!');
            }
            if (typeof options.successCallback === 'function') {
                options.successCallback(body);
            }
        },
        error: function (xhr, status, error) {
            if (options.formBlockContainer !== false) {
                $(options.formBlockContainer).unblock();
                enableForm(options.formElement);
            }

            if (typeof options.errorCallback === 'function') {
                options.errorCallback(xhr, status, error);
            }
        }
    };

    if (typeof options.processData !== 'undefined' || null) {
        ajaxOpts.data = options.data;
        ajaxOpts.enctype = 'multipart/form-data';
        ajaxOpts.processData = options.processData;
    }
    if (typeof options.contentType !== 'undefined' || null) {
        ajaxOpts.contentType = options.contentType;
        ajaxOpts.dataType = '';
    }

    if (options.formBlockContainer !== false) {
        $(options.formBlockContainer).block(window._loader.loading);
        disableForm(options.formElement);
    }

    return $.ajax(ajaxOpts)
}

const moeda2float = (moeda) => {
    moeda = moeda.replace(".", "");
    moeda = moeda.replace(",", ".");
    return parseFloat(moeda).toFixed(2);
}
window.moeda2float = moeda2float;

const betterMoeda2float = (moeda) => {
    moeda = moeda.replace(",", "");
    return parseFloat(moeda).toFixed(2);
}
window.betterMoeda2float = betterMoeda2float;

function currencyToFloat(value) {
    return parseFloat(value.replace(/,/g, "")).toFixed(2);
}
window.currencyToFloat = currencyToFloat;

const float2moeda = (num) => {
    x = 0;

    if (num < 0) {
        num = Math.abs(num);
        x = 1;
    }
    if (isNaN(num)) num = "0";
    cents = Math.floor((num * 100 + 0.5) % 100);

    num = Math.floor((num * 100 + 0.5) / 100).toString();

    if (cents < 10) cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + '.'
            + num.substring(num.length - (4 * i + 3));
    ret = num + ',' + cents;
    if (x == 1) ret = ' - ' + ret; return ret;
}

/**
 * @name getQueryParameters
 * @returns 
 */
const getQueryParameters = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function initDarkmode() {
    if (getCookie('DM')) {
        $('body').addClass('dark-mode');
        $('.navbar').removeClass('navbar-light');
        $('.navbar').removeClass('bg-light');
        $('.js-edit-stickers-table').removeClass('table-light');
        $('.navbar').addClass('navbar-dark');
        $('.navbar').addClass('bg-dark');
        $('.app-container').removeClass('app-theme-white');
        $('.app-container').addClass('app-theme-black');
        $('.js-switch-dark-mode').prop('checked', true);
    }

    $(document).on('click', '.js-switch-dark-mode', function () {
        // Pegar todos os switches de dark mode
        const $allSwitchers = $('.js-switch-dark-mode');

        if (!$('body').hasClass('dark-mode')) {
            if (!getCookie('DM')) {
                setCookie('DM', 1, 30);
            }

            // Ativar Dark Mode
            $('body').addClass('dark-mode');
            $('.navbar').removeClass('navbar-light');
            $('.navbar').removeClass('bg-light');
            $('.js-edit-stickers-table').removeClass('table-light');
            $('.navbar').addClass('navbar-dark');
            $('.navbar').addClass('bg-dark');
            $('.app-container').removeClass('app-theme-white');
            $('.app-container').addClass('app-theme-black');

            // Atualizar ícones em todos os switches
            $allSwitchers.each(function () {
                $(this).find('.fa-moon').addClass('d-none');
                $(this).find('.fa-sun').removeClass('d-none');
            });
        } else {
            if (getCookie('DM')) {
                eraseCookie('DM');
            }

            // Desativar Dark Mode
            $('body').removeClass('dark-mode');
            $('.navbar').addClass('navbar-light');
            $('.navbar').addClass('bg-light');
            $('.js-edit-stickers-table').addClass('table-light');
            $('.navbar').removeClass('navbar-dark');
            $('.navbar').removeClass('bg-dark');
            $('.app-container').addClass('app-theme-white');
            $('.app-container').removeClass('app-theme-black');

            // Atualizar ícones em todos os switches
            $allSwitchers.each(function () {
                $(this).find('.fa-moon').removeClass('d-none');
                $(this).find('.fa-sun').addClass('d-none');
            });
        }
    });

    // Configurar estado inicial dos ícones quando a página carrega
    $(document).ready(function () {
        const $allSwitchers = $('.js-switch-dark-mode');

        if ($('body').hasClass('dark-mode')) {
            $allSwitchers.each(function () {
                $(this).find('.fa-moon').addClass('d-none');
                $(this).find('.fa-sun').removeClass('d-none');
            });
        } else {
            $allSwitchers.each(function () {
                $(this).find('.fa-moon').removeClass('d-none');
                $(this).find('.fa-sun').addClass('d-none');
            });
        }

        let mountCountryListHTML = '<option value="" disabled selected>Selecione um país</option>';
        for (let i = 0; i < countryList.length; i++) {
            mountCountryListHTML += `<option value="${countryList[i].code}" ${countryList[i].code === 'BR' ? 'selected' : ''}>${countryList[i].name}</option>`;
        }

        let countrySelectors = $('.js-country-selector');
        if (countrySelectors.length > 0) {
            countrySelectors.each(function () {
                $(this).html(mountCountryListHTML);
            });
        }
    });
}

function reloadIcons() {
    // Limpar ícones antigos
    const oldIcons = document.querySelectorAll('[data-feather]');
    oldIcons.forEach(icon => {
        // Remover event listeners se houver
        const newIcon = icon.cloneNode(true);
        icon.parentNode.replaceChild(newIcon, icon);
    });

    // Limpar tooltips antigos do tippy
    const tippyInstances = document.querySelectorAll('[data-tippy-content]');
    tippyInstances.forEach(instance => {
        if (instance._tippy) {
            instance._tippy.destroy();
        }
    });

    // Recarregar ícones
    window.feather.replace();

    // Reinicializar tooltips
    tippy('[data-tippy-content]');
}

function validate2decimals(e) {
    e.value = e.value.replace(/,/g, ".");
    var t = e.value;
    e.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
}

function timeConverter(UNIX_timestamp, only_hour = false) {
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = (!only_hour ? (date + ' ' + month + ' ' + year) + ' ' : '') + (hour < 10 ? '0' : '') + '' + hour + ':' + (min < 10 ? '0' : '') + '' + min + ':' + (sec < 10 ? '0' : '') + '' + sec;
    return time;
}

function timeConverter2(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = date + ' ' + month + ' ' + year + ' ' + (hour < 10 ? '0' : '') + '' + hour + ':' + (min < 10 ? '0' : '') + '' + min + ':' + (sec < 10 ? '0' : '') + '' + sec;
    return time;
}

const getDatetime = (only_date = false, only_hour = false, set_hour = null, set_minutes = null) => {
    var date = new Date();

    if (set_hour != null) {
        date.setHours(set_hour);
    }
    if (set_minutes != null) {
        date.setMinutes(set_hour);
    }

    var seconds = date.getSeconds();
    var minutes = date.getMinutes();
    var hour = date.getHours();

    var year = date.getFullYear();
    var month = date.getMonth() + 1; // beware: January = 0; February = 1, etc.
    var day = date.getDate();

    return `${(only_date || (!only_date && !only_hour)) ? `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}` : ''}${(only_hour || (!only_date && !only_hour)) ? ` ${hour < 10 ? '0' : ''}${hour}:${minutes < 10 ? '0' : ''}${minutes}${!only_hour ? ':' + `${seconds < 10 ? '0' : ''}${seconds}` : ''}` : ''}`.trim();
}

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

function handleCopyToClipboardCodes() {
    // Get all the elements with <code> tag
    var codeElements = document.querySelectorAll("code");
    // Loop through each element and add a click event listener
    for (var i = 0; i < codeElements.length; i++) {
        codeElements[i].addEventListener("click", function (e) {
            // Get the clicked element
            var target = e.target;
            // Get its inside content
            var content = target.textContent;

            copyTextToClipboard(content);

            window.toast({
                error: false,
                text: 'Variável ' + content + ' copiada com sucesso.'
            });
        });
    }
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        //console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        //console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        //console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        //console.error('Async: Could not copy text: ', err);
    });
}

const isUserLoggedIn = () => {
    return window._sessionData.isLoggedIn
}

const getBusinessPayload = () => {
    let payload = {}
    if (window._sessionData.isSubdomain) {
        payload = {
            subdomain: window._sessionData.businessDomain
        }
    } else {
        payload = {
            domain: window._sessionData.businessDomain
        }
    }
    return payload;
}

const userHasRole = (role) => {
    var found = window._sessionData.roles.find((obj) => {
        return obj === role;
    });
    //console.log('userHasRole', role, found);
    return found;
}

const userHasBranch = (branchId) => {
    return window._sessionData.branchIds.find((obj) => {
        return obj == branchId;
    });
}

const getCategoryColor = (categoria) => {
    let $color = '';

    // tries to get color from windows._sessionData.patientTypes
    if (window._sessionData.patientTypes) {
        let patientType = window._sessionData.patientTypes.find((obj) => {
            return obj.DESCRICAO === categoria;
        });
        if (patientType) {
            $color = patientType.COR;
        }
    }

    // if not found, get color from agendaCategories
    if ($color === '') {
        let agendaCategory = window._sessionData.agendaCategories.find((obj) => {
            return obj.CATEGORIA === categoria;
        });
        if (agendaCategory) {
            $color = agendaCategory.COR;
        }
    }

    // if not found, get color from default categories
    if ($color === '') {
        switch (categoria) {
            case 'Vago PN': $color = '#ffc0cb'; break; // Rosa Claro TheQuiro
            case 'Vago PR': $color = '#ff33ff'; break; // Roxo TheQuiro
            case 'Atendido': $color = '#3ac47d'; break; // Verde
            case 'Agendado': $color = '#16aaff'; break; // Azul TheQuiro
            case 'Reagendado': $color = '#f7b924'; break; // Amarelo gema
            case 'Cancelado': $color = '#f54242'; break; // Vermelho
            case 'Não Compareceu': $color = '#f54242'; break; // Vermelho
            case 'Em Atendimento': $color = '#5a9150'; break; // Verde escuro
            case 'Presente': $color = '#9400d3'; break; // Roxo
            case 'Confirmado': $color = 'grey'; break; // Cinza
        }
    }
    return $color;
}

const getPatientRoleByPatientType = (patientType) => {
    let role = '';
    let patientTypeObj = window._sessionData.patientTypes.find((obj) => {
        return obj.SIGLA === patientType;
    });
    if (patientTypeObj) {
        role = patientTypeObj.ROLE;
    }
    return role;
}

const getPatientTypeDataByRole = (role) => {
    let data = '';
    let patientTypeObj = window._sessionData.patientTypes.find((obj) => {
        return obj.ROLE === role;
    });
    if (patientTypeObj) {
        data = patientTypeObj;
    }
    return data;
}

const getPatientTypeDataByAcronym = (acronym) => {
    let data = '';
    let patientTypeObj = window._sessionData.patientTypes.find((obj) => {
        return obj.SIGLA === acronym;
    });
    if (patientTypeObj) {
        data = patientTypeObj;
    }
    return data;
}

const getPatientTypeRoleByAcronym = (acronym) => {
    let role = '';
    let patientTypeObj = window._sessionData.patientTypes.find((obj) => {
        return obj.SIGLA === acronym;
    });
    if (patientTypeObj) {
        role = patientTypeObj.ROLE;
    }
    return role;
}

const copyToClipboardV2 = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
        document.execCommand('copy');
        console.log('Text copied to clipboard');
    } catch (err) {
        console.error('Unable to copy to clipboard:', err);
    } finally {
        document.body.removeChild(textarea);
    }
}

const copyToClipboardV1 = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
        document.execCommand('copy');
        console.log('Text copied to clipboard');
    } catch (err) {
        console.error('Unable to copy to clipboard:', err);
    } finally {
        document.body.removeChild(textarea);
    }
}

const isCurrentUserInAdminFeatureBlacklist = () => {
    console.log('isCurrentUserInAdminFeatureBlacklist', window._sessionData.blacklist_admin_financial_features, window._sessionData.userId);
    return window._sessionData.blacklist_admin_financial_features.includes(window._sessionData.userId);
}

function getCurrentUserData() {
    apiCall({
        method: 'GET',
        endpoint: 'api/v1/employee/me',
        successCallback: function (res) {
            console.log('utils.js/employee/me', res);
            if (!res.error) {
                $('.js-user-username').html(res.data.LOGIN);
                window._sessionData.email = res.data.EMAIL;
                window._sessionData.userId = res.data.LOGIN;
            } else {
                if (res.data.logged_out)
                    location.href = window._baseDir + 'logout';
                $('body').html(`
                    <div class="container my-5 py-5">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="error-template">
                                    <h1>
                                        Oops!</h1>
                                    <h2>
                                        Ocorreu um erro ao carregar informações, por favor, tente novamente.<br><small>Erro: (request-employee-info-internal-error)</small></h2>
                                    <div class="divider"></div>
                                    <a href="${getBaseDir()}logout" class="btn btn-primary">Sair do sistema</a>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
            }
        },
        errorCallback: function (err) {
            /*if (isLoggedIn)
                location.href = window._baseDir + 'logout';*/
            $('body').html(`
                <div class="container my-5 py-5">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    Ocorreu um erro ao carregar informações, por favor, tente novamente.<br><small>(request-employee-info-req-error)</small></h2>
                                <div class="divider"></div>
                                <a href="${getBaseDir()}logout" class="btn btn-primary">Sair do sistema</a>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }
    });
}

function OnBusinessReady() {
    let isLoggedIn = window._sessionData.isLoggedIn;
    if (!isLoggedIn)
        return;

    // Detecta alteração de seleção de filial, carrega lista de doutures e configura todos os campos
    $(document).on('change', '.js-business-branches-selector', function () {
        let branchId = $(this).val();
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/doctors',
            data: { branch_id: branchId },
            successCallback: function (res) {
                console.log('utils.js/business/doctors', res);
                if (!res.error) {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i in res.data) {
                        let brancheData = res.data[i];
                        if (brancheData.STATUS == 'A') {
                            html += `<option value="${brancheData.DOUTOR_ID}">${brancheData.PRIMEIRO_NOME}</option>`;
                        }
                    }
                    $('.js-business-doctors-selector').html(html);

                    html = '<option selected default value="">-- Selecione --</option>';
                    for (let i in res.data) {
                        let brancheData = res.data[i];
                        html += `<option value="${brancheData.DOUTOR_ID}">${brancheData.PRIMEIRO_NOME}</option>`;
                    }
                    $('.js-business-all-doctors-selector').html(html);

                    window.businessBranchDoctors = res.data;
                    window.doctorsReadyFunctions.forEach(function (fn) {
                        fn();
                    });
                } else {

                }
            },
            errorCallback: function (err) {

            }
        });
    });
}

function getBusinessDoctorsListByBranchId(id, callback) {
    apiCall({
        method: 'GET',
        endpoint: 'api/v1/business/doctors',
        data: { branch_id: id },
        successCallback: function (res) {
            console.log('utils.js/business/doctors', res);
            if (!res.error) {
                let html = '<option selected default value="">-- Selecione --</option>';
                for (let i in res.data) {
                    let brancheData = res.data[i];
                    html += `<option value="${brancheData.DOUTOR_ID}">${brancheData.PRIMEIRO_NOME}</option>`;
                }
                $('.js-business-doctors-selector').html(html);

                window.businessBranchDoctors = res.data;
                window.doctorsReadyFunctions.forEach(function (fn) {
                    fn();
                });

                callback();
            } else {

            }
        },
        errorCallback: function (err) {

        }
    });
}

function getNextBusinessDay() {
    const today = moment();
    let nextDay = today.clone().add(1, 'day');

    // Check if the next day is a weekend (Sunday)
    while (nextDay.isoWeekday() >= 7) {
        nextDay.add(1, 'day');
    }

    return nextDay; // You can format the result as needed
}

window.mobileCheck = function () {
    var isMobile = false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
    }
    return isMobile;
};

let calculateHoursAndMinutes = (timeLeft) => {
    let hours = Math.floor(timeLeft / 3600);
    let minutes = Math.floor((timeLeft % 3600) / 60);
    return `${hours}h ${minutes}m`;
}

function registerHeartbeat() {
    if (sendingHeartbeat)
        return;
    sendingHeartbeat = true;
    apiCall({
        method: 'POST',
        endpoint: 'api/v1/user/heartbeat',
        successCallback: function (res) {
            //console.log('utils.js/heartbeat', res);
            if (!res.error) {
                let timeLeft = parseInt(res.time_left);
                if (timeLeft > 0) {
                    $('#timeLeft').html(`<div style="width:100%; height:0px;"></div>Sessão expirará em ${calculateHoursAndMinutes(timeLeft)}`);
                } else {
                    $('#timeLeft').html('<div style="width:100%; height:0px;"></div>Sessão expirada.');
                }
            } else {
                $('#timeLeft').html('<div style="width:100%; height:0px;"></div>Sessão expirada.');
            }
            sendingHeartbeat = false;
        },
        errorCallback: function (err) {
            //console.log('utils.js/heartbeat', err);
            sendingHeartbeat = false;
        }
    });
}

function getOnlineUsers() {
    if (gettingUsers)
        return;
    gettingUsers = true;

    apiCall({
        method: 'GET',
        endpoint: 'api/v1/user/online',
        successCallback: function (res) {
            //console.log('utils.js/heartbeat', res);
            gettingUsers = false;

            if (!res.error) {
                let userListHtml = '';
                for (let i in res.data) {
                    let user = res.data[i];
                    userListHtml += `<div class="user">
                        <div class="status"></div>
                        ${user.LOGIN}
                    </div>`;
                }
                $("#userList").html(userListHtml);
            }
        },
        errorCallback: function (err) {
            //console.log('utils.js/heartbeat', err);
            gettingUsers = false;
        }
    });
}

function getUnseenTicketsNotifications() {
    if (gettingUnseenTicketsNotifications)
        return;
    gettingUnseenTicketsNotifications = true;

    apiCall({
        method: 'GET',
        endpoint: 'api/v1/internal-tickets/unseen',
        successCallback: function (res) {
            //console.log('utils.js/heartbeat', res);
            gettingUnseenTicketsNotifications = false;

            if (!res.error) {
                let unseenTickets = parseInt(res.data);
                let feedbackUnseenTickets = parseInt(res.data_feedback);
                if (unseenTickets > 0 || feedbackUnseenTickets > 0) {
                    toggleNotificationState(unseenTickets, feedbackUnseenTickets);
                    $('.vertical-time-simple').html('');
                    let html = '';
                    for (let i in res.tickets) {
                        let ticket = res.tickets[i];
                        html += `
                            <div
                                class="vertical-timeline-item dot-warning vertical-timeline-element js-internal-ticket-notification-${ticket.ID}">
                                <div>
                                    <span
                                        class="vertical-timeline-element-icon bounce-in"></span>
                                    <div
                                        class="vertical-timeline-element-content bounce-in">
                                        <p>${ticket.TITULO}
                                            <span class="text-success">${ticket.SOLICITANTE}</span>
                                        </p>
                                        <span class="vertical-timeline-element-date"></span>
                                    </div>
                                </div>
                            </div>
                        `;
                        $(`.js-internal-ticket-${ticket.ID}`).css('background-color', 'yellow');
                    }
                    $('.vertical-time-simple').html(html);
                } else {
                    toggleNotificationState(unseenTickets, feedbackUnseenTickets);
                }
            }
        },
        errorCallback: function (err) {
            //console.log('utils.js/heartbeat', err);
            gettingUnseenTicketsNotifications = false;
        }
    });
}

function toggleNotificationState(hasNotification, hasFeedbackNotification) {
    if (hasNotification || hasFeedbackNotification) {
        $('.icon-wrapper-bg').addClass('bg-danger');
        $('.ion-android-notifications').addClass('text-danger icon-anim-pulse');
        $('.badge-dot-sm').removeClass('d-none');
    } else if (!hasNotification || hasFeedbackNotification) {
        $('.icon-wrapper-bg').removeClass('bg-danger');
        $('.ion-android-notifications').removeClass('text-danger icon-anim-pulse');
        $('.badge-dot-sm').addClass('d-none');
        $('.vertical-time-simple').html('Sem notificações.');
    }

    $('.js-notifications-count').html(hasNotification);
    $('.js-feedbacks-notifications-count').html(hasFeedbackNotification);
}

function removeParam(paramName) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(paramName);
    if (history.replaceState) {
        let searchString = searchParams.toString().length > 0 ? '?' + searchParams.toString() : '';
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + searchString + window.location.hash;
        history.replaceState(null, '', newUrl);
    }
}

function currencyFormat(value) {
    if (typeof value === 'string') {
        value = parseFloat(value);
    }
    return value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
}

function getBranchNameFromId(id) {
    let branchName = '';
    for (let x in window._sessionData.businessBranches) {
        if (window._sessionData.businessBranches[x].ID == id) {
            branchName = window._sessionData.businessBranches[x].FILIAL;
            break;
        }
    }
    return branchName;
}

function getContractStatusName(status_id, check_upload = false, has_upload = false) {
    let badge_html = '',
        badge_classes = '',
        info_string = '';
    switch (status_id) {
        case 'A': {
            badge_html = `Ativo`
            if (check_upload) {
                if (has_upload == 'S') {
                    badge_classes = 'bg-success';
                    info_string = 'Contrato com todas assinaturas completas';
                } else {
                    badge_classes = 'bg-warning text-dark'
                    info_string = 'Não possui fluxo de assinaturas iniciado e/ou completo.'
                }
            }
            break;
        }
        case 'C': {
            badge_html = `Cancelado`
            badge_classes = 'bg-danger';
            info_string = 'O contrato está cancelado.';
            break;
        }
        case 'P': {
            badge_html = `Pendente`
            badge_classes = 'bg-warninng';
            info_string = 'O contrato está pendente.';
            break;
        }
        case 'T': {
            badge_html = `Transferido`
            badge_classes = 'bg-info text-dark';
            info_string = 'O contrato foi transferido ou recebido de alguém.';
            break;
        }
        case 'I': {
            badge_html = `Indicação de Tratamento`
            badge_classes = 'bg-secondary';
            info_string = 'Este contrato não possui valor real, é apenas o Tratamento Indicado pelo Quiro.';
            break;
        }
        case 'L': {
            badge_html = `Aguard. Liberação`
            badge_classes = 'bg-warning text-dark';
            info_string = 'Contrato aguardando liberação.';
            break;
        }
        case 'E': {
            badge_html = `Encerrado`
            badge_classes = 'bg-danger';
            info_string = 'Contrato foi encerrado.';
            break;
        }
        case 'B': {
            badge_html = `Bloqueado`
            badge_classes = 'bg-danger';
            info_string = 'Contrato bloqueado.';
            break;
        }
    }

    if (check_upload) {
        badge_html = `<span class="badge ${badge_classes}" data-tippy-content="${info_string}"><i class="fas fa-info-circle"></i> ${badge_html}</span>`
    }
    return badge_html;
}

function getWeekDayNameFromWeekDayId(id) {
    id = parseInt(id);
    switch (id) {
        case 1: return 'Segunda-feira';
        case 2: return 'Terça-feira';
        case 3: return 'Quarta-feira';
        case 4: return 'Quinta-feira';
        case 5: return 'Sexta-feira';
        case 6: return 'Sábado';
        case 7: return 'Domingo';
    }
}

function getSecUsers(callback) {
    apiCall({
        method: 'GET',
        endpoint: 'api/v1/business/security/users',
        successCallback: function (res) {
            console.log('utils.js/user/sec', res);
            if (!res.error) {
                window.secUsers = res.data;
                callback(res.data);
            }
        },
        errorCallback: function (err) {

        }
    });

}

function getCourtesyType(type) {
    switch (type) {
        case 'I': return 'Influencer';
        case 'F': return 'Funcionário';
        case 'C': return 'Cliente';
        case 'G': return 'Gift Card';
        case 'S': return 'Sócios';
        default: return '';
    }
}

function getInternalTicketCategoryType(type) {
    let categoryName = '';
    categoryName = window._sessionData.internalTicketsCategories.find((obj) => obj.ID == type);
    if (categoryName)
        return categoryName.CATEGORIA;
    else
        return "Categoria não encontrada";
}

function getPaymentMethod(id) {
    switch (id) {
        case 'C': return 'Cartão de Crédito';
        case 'D': return 'Cartão de Débito';
        case 'I': return 'Dinheiro';
        case 'P': return 'Pix';
        case 'T': return 'Transferência Bancária';
    }
}

function getCourtesyIsUsed(used) {
    return used == 'S' ? 'Sim' : 'Não';
}

function escapeSingleQuotes(jsonStr) {
    return jsonStr.replace(/'/g, '&#39;');
}

$(function () {
    //$('[data-toggle="tooltip"]').tooltip()
    if (typeof window.reloadIconss === 'function') {
        window.reloadIconss();
    }

    $(document).find('.child-modal').on('hidden.bs.modal', function () {
        console.log('hiding child modal');
        $('body').addClass('modal-open');
    });

    let isLoggedIn = window._sessionData.isLoggedIn,
        currentMenuId = window._sessionData.menuId,
        accountType = window._sessionData.accountType,
        currentLanguage = window._sessionData.currentLanguage;

    $(document).on('change', '.js-select-language', function () {
        console.log('update language', $(this).val());
        setCookie('' + window._sessionData.languageCookie + '', $(this).val(), 30);
        location.reload();
    });
    $(".js-select-language").val(currentLanguage);

    if (window._sessionData.businessDomain == 'marketing')
        return;

    $('div#loader-logo').height('auto');
    $('div.logo-src').css({
        'background': 'none',
    })

    apiCall({
        method: 'GET',
        endpoint: 'api/v1/business/get',
        data: getBusinessPayload(),
        successCallback: function (res) {
            console.log('utils.js/business/get', res);
            $('body').addClass('loaded');

            if (res.data.LOGO != null && res.data.LOGO != '') {
                let logoUrl = res.data.LOGO.toLowerCase().startsWith('https') ?
                    res.data.LOGO :
                    window._baseDir + res.data.LOGO;

                $('div#loader-logo').css({
                    'background-image': 'url(' + logoUrl + ')',
                })
                $('div.logo-src').css({
                    'background-image': 'url(' + logoUrl + ')',
                    'background-repeat': 'no-repeat',
                    'background-size': 'contain'
                })
                $('div#loader-logo').text(``);
            } else {
                $('div#loader-logo').height('auto');
                $('div.logo-src').css({
                    'background': 'none',
                    'height': 'auto'
                })
                $('div.logo-src').text(`UNNO`);
            }

            if (res.data.METADATA.favicon) {
                let faviconUrl = res.data.METADATA.favicon.toLowerCase().startsWith('https') ?
                    res.data.METADATA.favicon :
                    window._baseDir + res.data.METADATA.favicon;
                $('link[rel="icon"]').attr('href', faviconUrl);
            } else {
                $('link[rel="icon"]').attr('href', window._baseDir + 'assets/images/favicon.png');
            }

            if (res.data.METADATA.title) {
                // set page title
                document.title = res.data.METADATA.title;
            } else {
                document.title = 'UNNO - Sistema para Clínicas';
            }

            if (res.error) {
                if (isLoggedIn) {
                    //location.href = window._baseDir + 'logout';
                    return $('body').html(`
                        <div class="container my-5 py-5">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="error-template">
                                        <h1>
                                            Oops!</h1>
                                        <h2>
                                            Ocorreu um erro ao carregar informações, por favor, tente novamente.<br><small>(request-business-info-internal-error)</small></h2>
                                        <div class="divider"></div>
                                        <a href="${getBaseDir()}logout" class="btn btn-primary">Sair do sistema</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `);
                }

                $('.login-modal-body').html(`
                    <div class="container my-5 py-5">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="error-template">
                                    <h1>
                                        Oops!</h1>
                                    <h2>
                                        Este link não existe.</h2>
                                    <div class="divider"></div>
                                    <a href="${getBaseDir()}logout" class="btn btn-primary">Sair do sistema</a>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
                $('.login-modal-footer').html('');
            } else {
                window._sessionData.businessId = res.data.ID;
                window._sessionData.businessMetaData = res.data.METADATA;
                window._sessionData.contractWitnesses = res.data.METADATA.contractWitnesses;

                // First, remove the "bg-plum-plate" class
                $('.bg-animation').removeClass('bg-plum-plate');

                // Then set the background gradient using jQuery's .css() method
                $('.bg-animation').css({
                    'background-image': `linear-gradient(135deg, ${res.data.COR_CLARA} 0%, ${res.data.COR_ESCURA} 100%)`,
                    'background-color': '' // Reset any background color if it exists
                });

                // has "integracoes/conta-azul" in the URL
                let cached = 1;
                if (
                    window.location.href.indexOf('integracoes/conta-azul') > -1 ||
                    window.location.href.indexOf('financeiro/dashboard') > -1
                ) {
                    cached = 0;
                }

                if ($('.js-tpl-string-pagelet_login-title').length > 0) {
                    $('.js-tpl-string-pagelet_login-title').html(res.data.METADATA.strings.pages.pagelet_login.title);
                    $('.js-tpl-string-pagelet_login-subtitle').html(res.data.METADATA.strings.pages.pagelet_login.subtitle);
                }
                if ($('.js-tpl-string-copyright').length > 0) {
                    $('.js-tpl-string-copyright').html(res.data.METADATA.strings.general.copyright);
                }

                apiCall({
                    method: 'GET',
                    endpoint: 'api/v1/business/branches',
                    data: {
                        cached: cached
                    },
                    successCallback: function (res) {
                        console.log('utils.js/business/branches', res);
                        if (!res.error) {
                            window._sessionData.businessBranches = res.data;
                            let html = '<option selected default value="">-- Selecione --</option>';
                            for (let i in res.data) {
                                let brancheData = res.data[i];
                                html += `<option value="${brancheData.ID}">${brancheData.FILIAL}</option>`;
                            }
                            $('.js-business-branches-selector').html(html);

                            html = '<option selected default value="">-- Todas as Filiais --</option>';
                            for (let i in res.data) {
                                let brancheData = res.data[i];
                                html += `<option value="${brancheData.ID}">${brancheData.FILIAL}</option>`;
                            }
                            $('.js-business-branches-selector-type-2').html(html);

                            // let order by branch id 
                            let newOrder = res.data.sort((a, b) => a.ID - b.ID);
                            html = '<option selected default value="">-- Todas as Filiais --</option>';
                            for (let i in newOrder) {
                                let brancheData = newOrder[i];
                                let razaoSocial = brancheData.RAZAO_SOCIAL.split(' ')[0];
                                html += `<option value="${brancheData.ID}">${razaoSocial} - ${brancheData.FILIAL}</option>`;
                            }
                            $('.js-business-branches-selector-type-3').html(html);
                        } else {

                        }
                    },
                    errorCallback: function (err) {

                    }
                });

                if (isLoggedIn) {
                    setTimeout(function () {
                        getCurrentUserData();
                    }, 900);

                    // make a heartbeat apiCall to keep the session alive
                    setTimeout(function () {
                        registerHeartbeat();
                    }, 1500);
                    setInterval(function () {
                        registerHeartbeat();
                    }, 25000);

                    setTimeout(function () {
                        getOnlineUsers();
                    }, 3000);
                    // make a online users apiCall to get online users
                    setInterval(function () {
                        getOnlineUsers();
                    }, 60000);

                    setTimeout(function () {
                        getUnseenTicketsNotifications();
                    }, 4500);
                    // make a unseen tickets notifications apiCall to get unseen tickets notifications
                    setInterval(function () {
                        getUnseenTicketsNotifications();
                    }, 60000);
                    /*.bg-plum-plate{background-image:linear-gradient(135deg,#667eea 0%,#764ba2 100%)!important}
                    $('body')*/
                }
            }
        },
        errorCallback: function (err) {
            $('body').addClass('loaded');
            $('body').html(`
                <div class="container my-5 py-5">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    Ocorreu um erro ao carregar informações, por favor, tente novamente.<br><small>(request-business-info-req-error)</small></h2>
                                <div class="divider"></div>
                                <a href="${getBaseDir()}logout" class="btn btn-primary">Sair do sistema</a>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }
    });

    if (isLoggedIn) {

    }

    initDarkmode();
    handleCopyToClipboardCodes();

    if (!isLoggedIn)
        return;

    $('[data-toggle="tooltip"]').tooltip();
    let urlParms = getQueryParameters();
});

// Add an event listener to the input field with class "m2Decimals"
document.addEventListener('input', function (event) {
    const target = event.target;
    if (target.classList.contains('m2Decimals')) {
        // Get the entered value
        const value = target.value;

        // Remove non-numeric characters and multiple dots
        const sanitizedValue = value.replace(/[^0-9.]/g, '').replace(/\.{2,}/g, '.');

        // Update the input field value
        target.value = sanitizedValue;
    }
});

const getAgendaCategoryRoleByName = (name) => {
    let role = '';
    let category = window._sessionData.agendaCategories.find((obj) => {
        return obj.CATEGORIA === name;
    });
    if (category) {
        role = category.ROLE;
    }
    return role;
}

const getAgendaCategoryByRole = (role) => {
    let category = '';
    let categoryObj = window._sessionData.agendaCategories.find((obj) => {
        return obj.ROLE === role;
    });
    if (categoryObj) {
        category = categoryObj.CATEGORIA;
    }
    return category;
}

window.exportToExcelexportToExcel = (relatorio_nome, element_id) => {
    // Acquire Data (reference to the HTML table)
    var table_elt = document.getElementById(element_id);

    // Extract Data (create a workbook object from the table)
    var workbook = XLSX.utils.table_to_book(table_elt);

    // Process Data (add a new row)
    var ws = workbook.Sheets["Sheet1"];
    XLSX.utils.sheet_add_aoa(ws, [["Emitido em " + new Date().toISOString()]], { origin: -1 });

    // Package and Release Data (`writeFile` tries to write and save an XLSB file)
    XLSX.writeFile(workbook, '' + relatorio_nome + '_' + window.getSaoPauloDateTime() + '.xlsx');
}

function mountSortList(targetid, sortsize, lastItemConfig, minus = null) {
    /*let sortList = [];
    for(let i = 0; i < sortsize - 1; ++i) {
        sortList.push([i,1]);
    }*/
    sortsize = $(sortsize).length;
    $(targetid).tablesorter({
        sortList: [
            [(sortsize - (minus ? minus : 1)), lastItemConfig]
        ]
    });
}

window.feather.replace();
window.validate2decimal = function (e) { validate2decimals(e) };
window.timeConverter = function (e) { timeConverter(e) };
window.copyToClipboardV2 = copyToClipboardV2;
window.copyToClipboardV1 = copyToClipboardV1;
window.reloadIconss = function () { reloadIcons(); }
window.mountSortList = mountSortList;
window.businessReadyFunctions.push(OnBusinessReady);

exports.getBaseDir = getBaseDir;
exports.disableForm = disableForm;
exports.enableForm = enableForm;
exports.apiCall = apiCall;
exports.moeda2float = moeda2float;
exports.float2moeda = float2moeda;
exports.getQueryParameters = getQueryParameters;
exports.timeConverter = timeConverter;
exports.timeConverter2 = timeConverter2;
exports.getDatetime = getDatetime;
exports.currencyFormat = currencyFormat;
exports.sha256 = sha256;
exports.copyToClipboardV1 = copyToClipboardV1;
exports.copyToClipboardV2 = copyToClipboardV2;
exports.getNextBusinessDay = getNextBusinessDay;
exports.escapeSingleQuotes = escapeSingleQuotes;
exports.currencyToFloat = currencyToFloat;
exports.betterMoeda2float = betterMoeda2float;

exports.getGameTypeFromBotType = getGameTypeFromBotType;
exports.isUserLoggedIn = isUserLoggedIn;
exports.userHasRole = userHasRole;
exports.userHasBranch = userHasBranch;
exports.getCategoryColor = getCategoryColor;
exports.getBranchNameFromId = getBranchNameFromId;
exports.getBusinessDoctorsListByBranchId = getBusinessDoctorsListByBranchId;
exports.getContractStatusName = getContractStatusName;
exports.getWeekDayNameFromWeekDayId = getWeekDayNameFromWeekDayId;
exports.getCourtesyType = getCourtesyType;
exports.getCourtesyIsUsed = getCourtesyIsUsed;
exports.getInternalTicketCategoryType = getInternalTicketCategoryType;
exports.getPatientRoleByPatientType = getPatientRoleByPatientType;
exports.getPatientTypeDataByRole = getPatientTypeDataByRole;
exports.getPatientTypeDataByAcronym = getPatientTypeDataByAcronym;
exports.getPatientTypeRoleByAcronym = getPatientTypeRoleByAcronym;
exports.getAgendaCategoryRoleByName = getAgendaCategoryRoleByName;
exports.getAgendaCategoryByRole = getAgendaCategoryByRole;
exports.getPaymentMethod = getPaymentMethod;

exports.getSecUsers = getSecUsers;

exports.removeParam = removeParam;
exports.isCurrentUserInAdminFeatureBlacklist = isCurrentUserInAdminFeatureBlacklist;
exports.toggleNotificationState = toggleNotificationState;

exports.mountSortList = mountSortList;